import React from 'react';
import ModalBtnClose from '/assets/icon/global/modal-btn-close.svg';

interface IProps {
  title: string;
  modalClose: any;
}

const CustomModalHeader = (props: IProps) => {
  return (
    <div className="custom-modal-header d-flex justify-content-between">
      <span>{props.title}</span>
      <img src={ModalBtnClose} alt={'팝업닫기'} onClick={props.modalClose} />
    </div>
  );
};

export default CustomModalHeader;
